export default __webpack_public_path__ + "img/WB_RTK_NOMA_EF.e3884ab9faa8e6cdda2f926c10295645.jpg";